import Image from 'next/image';
import Icon from './arrow_right.svg?url';
import type { SvgImageProps } from '../_type';

export const ArrowRightBlackImage: React.FC<SvgImageProps> = ({
  alt,
  ...props
}) => <Image src={Icon} alt={alt} {...props} />;
